var __TEMP__ = require('./_baseSlice.js');var baseSlice = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */
function tail(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 1, length) : [];
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = tail;
